import React, { useState } from 'react';
import { Heart } from 'react-feather';
import useTranslation from 'next-translate/useTranslation';
import { style, useAuthentication, useLikeTrack, useTrack } from '../../api';
import AuthenticationPopupDialog from '../../components/Modals/AuthenticationPopupDialog';

import CentralizeButton from './CentralizeButton';

export interface LikeProps {
  trackId: number;
  className?: string;
  iconOnly?: boolean;
  size?: number;
}

export default function VuexyLike({ trackId }: LikeProps) {
  const [track] = useTrack(trackId);
  const { t } = useTranslation('tracks');
  const { like, unlike } = useLikeTrack(trackId);
  const { isLoggedIn } = useAuthentication();
  const [isAuthenticationDialogOpen, setIsAuthenticationDialogOpen] = useState(
    false,
  );

  const tl = (
    pathToTranslation: string, // translate with 'as string' to avoid type error
  ) => t(`${pathToTranslation}` as string);

  const handleAuthenticationDialogClose = () => {
    setIsAuthenticationDialogOpen(false);
  };
  const handleAuthenticationDialogOpen = () => {
    setIsAuthenticationDialogOpen(true);
  };

  if (track === undefined) {
    return null;
  }

  if (track.logged_in_user_liked_track && isLoggedIn) {
    return (
      <CentralizeButton
        onClick={() => unlike()}
        text={tl('tracks:like')}
        outline
        color="dark"
        className="text-primary d-flex br-5"
        icon={Heart}
        iconSize="14"
        isIconLeftSide
        size="sm"
        iconFill={style.primary_pink_new}
      />
    );
  }

  return (
    <>
      <AuthenticationPopupDialog
        isOpen={isAuthenticationDialogOpen}
        onClose={handleAuthenticationDialogClose}
      />

      <CentralizeButton
        onClick={() => {
          if (isLoggedIn) {
            like();
          } else {
            handleAuthenticationDialogOpen();
          }
        }}
        outline
        color="dark"
        className="text-dark d-flex br-5"
        icon={Heart}
        isIconLeftSide
        iconSize="14"
        text={tl('tracks:like')}
        size="sm"
      />
    </>
  );
}
